import { getOpenCV } from "./opencv";

// ORB feature extraction
export async function extractORBFeatures(imageElement, maxFeatures = 1500) {
  if (!imageElement) {
    throw new Error("extractORBFeatures requires an image element.");
  }

  const cv = await getOpenCV();

  let source = null;
  let gray = null;
  let mask = null;
  let keypointVector = null;
  let descriptors = null;
  let orb = null;

  try {
    source = cv.imread(imageElement);
    gray = new cv.Mat();

    cv.cvtColor(source, gray, cv.COLOR_RGBA2GRAY);

    mask = new cv.Mat();
    keypointVector = new cv.KeyPointVector();
    descriptors = new cv.Mat();
    orb = new cv.ORB(maxFeatures);

    orb.detectAndCompute(gray, mask, keypointVector, descriptors);

    const keypoints = [];

    for (let i = 0; i < keypointVector.size(); i += 1) {
      const keypoint = keypointVector.get(i);

      keypoints.push({
        x: keypoint.pt.x,
        y: keypoint.pt.y,
        size: keypoint.size,
        angle: keypoint.angle,
        response: keypoint.response,
        octave: keypoint.octave,
      });
    }

    const descriptorRows = descriptors.rows;
    const descriptorCols = descriptors.cols;
    const descriptorData = new Uint8Array(descriptors.data);
    const descriptorCopy = new Uint8Array(descriptorData);

    return {
      keypoints,
      descriptors: {
        rows: descriptorRows,
        cols: descriptorCols,
        data: descriptorCopy,
      },
      width: source.cols,
      height: source.rows,
    };
  } finally {
    if (orb) {
      orb.delete();
    }

    if (descriptors) {
      descriptors.delete();
    }

    if (keypointVector) {
      keypointVector.delete();
    }

    if (mask) {
      mask.delete();
    }

    if (gray) {
      gray.delete();
    }

    if (source) {
      source.delete();
    }
  }
}
